export function getText(obj: Ii18nText[], lang = 'en'): string {
  if (obj && obj.length > 0) {
    const o = obj.find(o => o.lang === lang)
    return o ? o.text : ''
  } return ''
}

export function getTextIndex(obj: Ii18nText[], lang = 'en'): number {
  if (obj && obj.length > 0) {
    return obj.findIndex(o => o.lang === lang)
  } return -1
}

export function setText(text: string, obj: Ii18nText[], lang = 'en'): Ii18nText[] {
  if (obj) {
    const i = obj.findIndex(o => o.lang === lang)
    if (i === -1) {
      // no match found for the language, we push instead
      obj.push({ text, lang })
    } else {
      obj[i].text = text
    }
  }
  return obj
}

/**
 * Analyzes an i18n text array and returns indices of duplicate entries to remove.
 * When duplicates exist for a language, keeps the entry that has text content.
 * @param fields Array of i18n text entries (with id from useFieldArray)
 * @returns Object with indicesToRemove array and needsDefault boolean
 */
export function deduplicateI18nFields<T extends Ii18nText>(
  fields: T[]
): { indicesToRemove: number[]; needsDefault: boolean } {
  if (!fields || fields.length === 0) {
    return { indicesToRemove: [], needsDefault: true }
  }

  const byLang = new Map<string, { index: number; hasText: boolean }>()
  const indicesToRemove: number[] = []

  fields.forEach((field, index) => {
    const lang = field.lang || 'en'
    const existing = byLang.get(lang)
    const hasText = Boolean(field.text?.trim())

    if (!existing) {
      byLang.set(lang, { index, hasText })
    } else if (hasText && !existing.hasText) {
      indicesToRemove.push(existing.index)
      byLang.set(lang, { index, hasText })
    } else {
      indicesToRemove.push(index)
    }
  })

  // Sort in reverse order so removal doesn't affect indices
  indicesToRemove.sort((a, b) => b - a)

  return { indicesToRemove, needsDefault: false }
}
